import { makeStyles } from '@material-ui/core/styles';

import { bottomButtonsBackground } from 'Styles/theme';

export const useStyles = makeStyles(theme => ({
	container: {
		height: '100%',
		width: '100%',
		maxWidth: '100%',
		padding: 0,
		overflow: 'hidden'
	},
	card: {
		position: 'fixed',
		width: 333,
		top: 100,
		left: 50,
		zIndex: 1234,
		overflowY: 'auto',
		maxHeight: 'calc(100vh - 30vh)',
		[theme.breakpoints.down('sm')]: {
			left: '50%',
			marginLeft: -166,
			top: '10%',
			maxHeight: 'calc(90vh - 10vh)'
		}
	},
	centeredCard: {
		top: '20%',
		left: '50%',
		marginTop: 0,
		marginLeft: -166,
		maxHeight: 'calc(80vh - 20vh)',
		[theme.breakpoints.down('sm')]: {
			top: '10%',
			maxHeight: 'calc(90vh - 10vh)'
		}
	},
	backgroundImage: {
		height: '100%',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover'
	},
	backgroundLogo: {
		marginLeft: '3.33%',
		marginRight: '3.33%'
	},
	blackLine: {
		width: '100%',
		height: 10,
		backgroundColor: '#000'
	},
	cardContentRoot: {
		padding: 0 + ' !important',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		height: '100%'
	},
	cardHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		paddingTop: 30,
		paddingBottom: 35
	},
	cardLogo: {
		maxHeight: 60,
		maxWidth: 200,
		paddingTop: 10,
		paddingBottom: 10
	},
	cardTitle: {
		fontSize: 16,
		fontWeight: 500
	},
	cardContent: {
		width: '83%',
		backgroundColor: bottomButtonsBackground,
		padding: 30,
		flex: 1
	},
	cardContentTitle: {
		fontSize: 16,
		fontWeight: 500,
		marginBottom: 10
	},
	cardContentSubTitle: {
		fontSize: 14,
		marginBottom: 20
	},
	cardContentInputBox: {
		marginBottom: 20
	},
	cardContentInput: {},
	cardContentInputItem: {
		backgroundColor: '#FFF',
		padding: '11px 14px'
	},
	privacyPolicyWrapper: {
		marginTop: 20
	},
	privacyPolicyLabelRoot: {
		textAlign: 'justify'
	}
}));
